<div class="template-display" id="template-selector">
  <div *ngFor="let template of templates" [class]="selected && selected.id === template.id ? 'template-container template-selected' : 'template-container'" (click)="selectDossier(template)">
    <div class="template-placeholder">
      <img src="../../../../assets/img/templates/standard.svg">
    </div>
    <p class="template-text">{{template.name}}</p>
  </div>
</div>
